export default "__VITE_ASSET__CSaPinDN__"